var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyperpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 18C36.5 8.05888 28.4411 0 18.5 0C8.55888 0 0.5 8.05888 0.5 18C0.5 27.9411 8.55888 36 18.5 36C26.7332 36 33.6753 30.4724 35.8177 22.9259C36.2621 21.3604 36.5 19.708 36.5 18ZM10.79 10.1536H23.8842C28.3494 10.1536 30.0737 12.2006 30.2415 14.6823C30.7026 20.6952 25.3057 22.4336 21.8809 22.4336H19.4422L18.3264 27.2305H13.4216L14.5634 22.4336H7.19233L8.18199 18.692H22.664C24.0925 18.7257 25.4213 17.8076 25.4213 16.3197C25.408 15.1837 24.4895 14.0694 22.969 14.0944C21.8618 14.0944 20.3323 14.8566 20.0365 18.0254C20.0323 18.0417 19.695 18.0501 19.0247 18.0508H18.8395C18.1105 18.0501 17.0484 18.0417 15.6533 18.0254L16.5223 14.0979H9.73596L10.79 10.1536Z",
    fill: "#006EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperpay);
export default __webpack_public_path__ + "static/media/hyperpay.5c7d9b945e6da0ad899412c8e6e085fd.svg";
export { ForwardRef as ReactComponent };